import { IRapportInfo } from '../../../../../Types/RapportInfoType';
// import { rapportInfos } from '../RapportInfo';

const DIRapportMeny: IRapportInfo[] = [];

export default DIRapportMeny;
